<template>
    <div>
        <b-modal id="edit_user_modal" @ok="edit_user">
            <template slot="modal-title">Edit a user</template>
            <form ref="edit_user_form">
                <b-form-group
                        label="First name"
                        label-for="first-name"
                        invalid-feedback="First name is required">
                    <b-form-input
                            id="first-name"
                            :state="validate_fn"
                            v-model="selected_user.firstname"
                            required/>
                </b-form-group>
                <b-form-group
                        label="Last name"
                        label-for="last-name"
                        invalid-feedback="Last name is required">
                    <b-form-input
                            id="last-name"
                            :state="validate_ln"
                            v-model="selected_user.lastname"
                            required/>
                </b-form-group>
                <b-form-group
                        label="Email adres"
                        label-for="email">
                    <b-form-input
                            id="email"
                            :state="validate_email"
                            v-model="selected_user.email"
                            required/>
                    <b-form-invalid-feedback :state="validate_email">
                        Email adres is invalid.
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group
                        label="User roles"
                        label-for="roles">
                    <b-form-select
                            id="roles"
                            :state="validate_roles"
                            v-model="selected_user.roles"
                            multiple
                            :options="options"
                            required/>
                    <b-form-invalid-feedback :state="validate_roles">
                        Select roles.
                    </b-form-invalid-feedback>
                </b-form-group>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import UserRepository from '../../repositories/user.repository';
    import RoleRepository from '../../repositories/role.repository';

    export default {
        props: {
            selected_user: {
                type: Object,
                default: UserRepository.blankUser,
            }
        },
        data() {
            let options = [];
            RoleRepository.getAllRoles().then(res => {
                let roles = res.data["roles"];
                roles.forEach(role => {
                    options.push({value: role, text: role})
                });
            });
            return {
                options: options,
            }
        },
        methods: {
            checkFields() {
                if (UserRepository.validate.firstName(this.selected_user.firstname) === false) return false;
                if (UserRepository.validate.lastName(this.selected_user.lastname) === false) return false;
                if (UserRepository.validate.email(this.selected_user.email) === false) return false;
                if (UserRepository.validate.roles(this.selected_user.roles) === false) return false;
                return true;
            },
            edit_user(modal) {
                if (this.$refs.edit_user_form.checkValidity() && this.checkFields()) {
                    this.$emit('show-loading-pop-up', 'Saving the changes to the selected user.');
                    UserRepository.put(this.selected_user.id, this.selected_user).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('user-edited', res.data);
                        // Notify the user.
                        this.$bvToast.toast(`User ${res.data.firstname + ' ' + res.data.lastname} successfully edited.`, {
                            title: `User edited.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$emit('reset-loading-pop-up');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the user. Check the value\'s of all the fields', {
                                title: `User edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while editing the user.', {
                                title: `User edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validate_fn() {
                return UserRepository.validate.firstName(this.selected_user.firstname);
            },
            validate_ln() {
                return UserRepository.validate.lastName(this.selected_user.lastname);
            },
            validate_email() {
                return UserRepository.validate.email(this.selected_user.email);
            },
            validate_roles() {
                return UserRepository.validate.roles(this.selected_user.roles);
            },
            validate_password() {
                return UserRepository.validate.password(this.selected_user.password);
            },
            validate_password_again() {
                return UserRepository.validate.passwordRepeat(this.selected_user.password, this.selected_user.passwordRepeat);
            }
        }
    }
</script>
